$(window).on("load", function() {
	const alerts = [...document.querySelectorAll(".alert")];
	let dismissedIdArray = localStorage.getItem("tasbAlertIdsDismissed") ? [...JSON.parse(localStorage.getItem("tasbAlertIdsDismissed"))] : [];

	let firstAvailAlert = () => alerts.find(a => {
		let id = a.getAttribute("data-alert-id");
		return !dismissedIdArray.includes(id);
	}) || false;
	
	const closeAlert = alertNode => {
		let alertId = alertNode.getAttribute("data-alert-id");
		alertNode.classList.remove("alert--showing");
		dismissedIdArray.push(alertId);
		localStorage.removeItem("tasbAlertIdsDismissed");
		localStorage.setItem("tasbAlertIdsDismissed", JSON.stringify(dismissedIdArray));
		if (firstAvailAlert()) {
			alertSetup(firstAvailAlert());
		} else {
			alertSetup(null);
		}
	}

	const alertSetup = alert => {
		const pageIsOrg = !!document.querySelector(".page--ORG, .page--BUY, .page--BOB, .page--TXC, .page--TSP, .page--ENC");
		const $headerMenuContainer = pageIsOrg ? $(".header") : $(".header__menu-container");
		const setHeightValues = (height) => {
			if (alert && alert.matches(".alert--main-content")) return; // added when we were considering using alerts in main pag content that weren't dismissable
			$(".page").css("padding-top", `${height}px`);
			if (pageIsOrg) {
				$headerMenuContainer.css("top", `${height}px`);
				return;
			}
			if (window.innerWidth <= 1198 && window.innerWidth > 767) {
				$headerMenuContainer.css("top", `${height + 80}px`);
				$headerMenuContainer.css("min-height", `calc((var(--vh, 1vh) * 100) - ${height + 80}px`);
			} else if (window.innerWidth < 768) {
				$headerMenuContainer.css("top", `${height + 66}px`);
				$headerMenuContainer.css("min-height", `calc((var(--vh, 1vh) * 100) - ${height + 66}px`);
			} else if (window.innerWidth > 1198) {
				$headerMenuContainer.css("top", ``);
				$headerMenuContainer.css("min-height", ``);
			}
		}

		if (!alert) {
			setHeightValues(0);
			return;
		}

		let alertId = alert.getAttribute("data-alert-id");
		let alertIsDismissed = dismissedIdArray && dismissedIdArray.length > 0 ? dismissedIdArray.includes(alertId) : false;

		if (alertIsDismissed) return;
		else  {
			const close = alert.querySelector("button.alert__close");
		
			const showAlert = () => {
				alert.classList.add("alert--showing");
				setHeightValues(alert.offsetHeight);
			}
			
			if (!alertIsDismissed) {
				showAlert();
				
				$(window).resize(() => {
					let height = alert.offsetHeight;
					setHeightValues(height);
					alert.style.top = "";
				})
			
				close.onclick = () => closeAlert(alert);
			}
		}
	}

	alertSetup(firstAvailAlert());
});